/* ParfumLab_Web_FINAL tasarımı: header davranışı (tasarımdaki setMega / initFinal / menuPanel ile aynı).
   - Masaüstü mega menü: fareyle kategori üstüne gelince açılır, çıkınca 160 ms sonra kapanır; ok düğmesi
     tıklamayla açar/kapatır; Esc kapatır; ↓ menüyü açıp ilk bağlantıya odaklanır; dışarı tıklayınca kapanır.
   - Mobil menü: + düğmesi alt kategorileri satırın altında açar (× olur); menü kapanınca hepsi kapanır. */
(function () {
  var current = '';
  var timer = null;
  var hoverMq = window.matchMedia('(hover: hover)');
  var desktopMq = window.matchMedia('(min-width: 990px)');

  function cats() { return document.querySelectorAll('.plw-navcat'); }

  function setMega(key, focus) {
    clearTimeout(timer);
    if (!desktopMq.matches) key = '';
    current = key || '';
    cats().forEach(function (cat) {
      var open = cat.dataset.plwMega === current;
      var menu = cat.querySelector('.plw-mega');
      var toggle = cat.querySelector('.plw-mega-toggle');
      cat.classList.toggle('is-open', open);
      if (menu) {
        menu.hidden = !open;
        /* Tam genişlik panelde liste, kategori yazısının 28px sağından başlar; sağa taşmaz */
        if (open) {
          var link = cat.querySelector('.plw-navcat__link');
          var base = menu.getBoundingClientRect().left;
          var x = link.getBoundingClientRect().left - base + 28;
          var max = menu.getBoundingClientRect().width - 353 - 32;
          menu.style.setProperty('--plw-mega-x', Math.round(Math.max(16, Math.min(x, max))) + 'px');
        }
      }
      if (toggle) toggle.setAttribute('aria-expanded', String(open));
    });
    if (focus && current) {
      var first = document.querySelector('#plw-mega-' + current + ' a');
      if (first) first.focus();
    }
  }

  document.addEventListener('pointerover', function (event) {
    if (!hoverMq.matches || !event.target.closest) return;
    var cat = event.target.closest('.plw-navcat');
    if (cat) { clearTimeout(timer); if (current !== cat.dataset.plwMega) setMega(cat.dataset.plwMega); }
  });
  document.addEventListener('pointerout', function (event) {
    if (!event.target.closest) return;
    var cat = event.target.closest('.plw-navcat');
    if (cat && !cat.contains(event.relatedTarget)) timer = setTimeout(function () { setMega(''); }, 160);
  });
  document.addEventListener('focusin', function (event) {
    if (!current || !event.target.closest) return;
    var cat = event.target.closest('.plw-navcat');
    if (!cat || cat.dataset.plwMega !== current) setMega('');
  });
  document.addEventListener('keydown', function (event) {
    if (!event.target.closest) return;
    if (current && event.key === 'Escape') {
      var trigger = document.querySelector('.plw-navcat[data-plw-mega="' + current + '"] .plw-mega-toggle');
      setMega('');
      if (trigger) trigger.focus();
    }
    if (event.key === 'ArrowDown') {
      var cat = event.target.closest('.plw-navcat');
      if (cat && !event.target.closest('.plw-mega')) { event.preventDefault(); setMega(cat.dataset.plwMega, true); }
    }
  });
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var toggle = event.target.closest('.plw-mega-toggle');
    if (toggle) {
      event.preventDefault();
      var key = toggle.closest('.plw-navcat').dataset.plwMega;
      setMega(current === key ? '' : key);
      return;
    }
    if (current && !event.target.closest('.plw-navcat')) setMega('');

    var sub = event.target.closest('.plw-entry__toggle');
    if (sub) {
      var on = sub.getAttribute('aria-expanded') === 'true';
      var panel = document.getElementById(sub.getAttribute('aria-controls'));
      sub.setAttribute('aria-expanded', String(!on));
      if (panel) panel.hidden = on;
    }
  });
  var onDesktopChange = function () { if (!desktopMq.matches) setMega(''); };
  if (desktopMq.addEventListener) desktopMq.addEventListener('change', onDesktopChange);

  /* Mobil menü kapanınca alt kategoriler kapalı başlar (tasarımda panel her açılışta yeniden çizilir) */
  document.addEventListener('menudrawer:close', function () {
    document.querySelectorAll('.plw-entry__toggle[aria-expanded="true"]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', 'false');
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.hidden = true;
    });
  });
})();
